





































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import { WeeklyMeeting, WeeklyMeetingInformation } from '../common/form-type.interface';
import { LooseObject, MonthYear } from '../common/common-type.interface';

import util from '../common/utility';

@Component({})
export default class extends Vue {
    @Prop() public weeklyMeeting: WeeklyMeeting | any;
    public classes: LooseObject[] = [];

    @Prop() private month: any;
    @Prop() private year: any;

    public created() {
        this.addClass();

        this.nextFormValidation(false);
    }

    public saveData(data: string) {
        util.eventBus.$emit('data', { type: 'weeklyMeeting', data });
    }

    public addNewMeetingDetails() {
        this.weeklyMeeting.data.meetings.push({
            date: '',
            totalPresent: '',
            teachingTopic: '',
            preacher: '',
            remarks: '',
            id: Date.now()
        });

        this.classes.push({
            date: {'is-valid': false, 'is-invalid': true},
            totalPresent: {'is-valid': false, 'is-invalid': true},
            teachingTopic: {'is-valid': false, 'is-invalid': true},
            preacher: {'is-valid': false, 'is-invalid': true},
            remarks: {'is-valid': false, 'is-invalid': true}
        });

        this.saveData('new');
    }
    public removeMeetingDetails(index: number) {
        this.weeklyMeeting.data.meetings.splice(index, 1);

        this.classes.splice(index, 1);

        this.saveData('removed: ' + index);
    }

    public validateInput(event: Event, index: number, name: string) {
        const val = (event.target as HTMLFormElement).value.trim();

        let error = false;

        switch ( name ) {
            case 'date':
                error = util.isInvalidMonthYear(this.month, this.year, val);
                break;
            case 'teachingTopic':
            case 'preacher':
            case 'remarks':
                error = val === '';
                break;
            case 'totalPresent':
                error = +val <= 0;
                break;
        }

        this.classes[index][name]['is-invalid'] = error;
        this.classes[index][name]['is-valid'] = !error;
    }

    public nextFormValidation(submitForm: boolean) {
        if ( this.weeklyMeeting.data.hadMeeting === 'yes' ) {
            // 1a - YES Validation
            let yesValidity = true;

            this.weeklyMeeting.data.meetings.forEach( (v: any, i: number) => {
                for (const key in this.classes[i]) {
                    if ( this.classes[i].hasOwnProperty(key) ) {
                        let error = false;

                        if ( key === 'totalPresent' ) {
                            error = v.totalPresent <= 0;
                        } else if (key === 'date') {
                            error = util.isInvalidMonthYear(this.month, this.year, v.date);
                        } else {
                            error = v[key].trim() === '';
                        }

                        this.classes[i][key]['is-invalid'] = error;
                        this.classes[i][key]['is-valid'] = !error;

                        if ( error ) {
                            yesValidity = false;
                        }
                    }
                }
            });

            this.weeklyMeeting.isValid = yesValidity;
        } else {
            // 1b - NO Validation
            this.weeklyMeeting.isValid = this.weeklyMeeting.data.noMeetingRemarks.trim() !== '';
        }

        // 2 - if form is valid then submit and go to next form
        if ( submitForm && this.weeklyMeeting.isValid ) {
            this.$router.push('core-team-meetings');
        }
    }

    get isInvalid() {
        let error = false;

        if (this.weeklyMeeting.data.hadMeeting === 'yes') {
            this.classes.forEach((row: LooseObject, index: number) => {
                for ( const key in row ) {
                    if ( row[key]['is-invalid'] ) {
                        error = true;
                    }
                }
            });
        } else {
            error = this.weeklyMeeting.data.noMeetingRemarks.trim() === '';
        }

        this.weeklyMeeting.isValid = !error;

        return error;
    }

    get MonthYear(): MonthYear {
        return {
            month: +this.month,
            year: +this.year
        };
    }

    private addClass() {
        this.weeklyMeeting.data.meetings.forEach( (meeting: WeeklyMeetingInformation) => {
            const classes: LooseObject = {};

            for ( const key in meeting ) {
                if (key !== 'id') {
                    classes[key] = { 'is-valid': false, 'is-invalid': true };
                }
            }

            this.classes.push(classes);
        });
    }

    get minDate() {
        return this.year + '-' + util.addZero(this.month) + '-01';
    }

    get maxDate() {
        const maxDate = new Date(this.year, this.month, 0);

        return this.year + '-' + util.addZero((maxDate.getMonth() + 1)) + '-' + maxDate.getDate();
    }

    @Watch('MonthYear')
    private watchMonthYear(monthYear: MonthYear, oldValue: MonthYear) {
        if (oldValue && oldValue.month !== 0) {
            this.weeklyMeeting.data.meetings.forEach((meeting: WeeklyMeetingInformation, index: number) => {
                const error = util.isInvalidMonthYear(this.month, this.year, meeting.date);

                this.classes[index].date['is-invalid'] = error;
                this.classes[index].date['is-valid'] = !error;

                if ( error && this.weeklyMeeting.isValid ) {
                    this.weeklyMeeting.isValid = false;
                }
            });
        }
    }
}
